/* eslint no-use-before-define: 0 */  // --> OFF
<template>
  <form @submit.prevent="confirm()">
    <div>
      <div class="form-group col-xs-12">
        <label for="id">Numéro du contenant</label>
        <input type="text" class="form-control" id="id" v-model="collecte.reference" maxlength="50" required>
        <div class="invalid-feedback" v-if="referenceExists" style="color: red;">
          Un contenant avec le même numéro existe déjà dans la base de données !
        </div>
      </div>
      <div class="form-group">
        <div class="col-xs-2">
          <label for="numero">Numero</label>
          <input type="text" class="form-control" id="numero" v-model="collecte.numero" maxlength="50">
        </div>
        <div class="col-xs-10">
          <label for="adresse">Adresse</label>
          <input type="text" class="form-control" id="adresse" v-model="collecte.adresse" maxlength="50" required>
        </div>
      </div>
      <div class="form-group col-xs-12">
        <label for="coltype">Type de collecte</label>
        <div>
          <div id="coltype" class="radio">
            <label>
              <input type="radio" name="arrondissement" value="CORBEILLE" v-model="collecte.typeContenant" required>
              {{ 'CORBEILLE' | collecteType }}
            </label>
          </div>
          <div class="radio">
            <label>
              <input type="radio" name="arrondissement" value="CANIBOX" v-model="collecte.typeContenant" required>
              {{ 'CANIBOX' | collecteType }}
            </label>
          </div>
        </div>
        <div class="form-group">
          <label for="cantonnier">Secteur</label>
          <select v-model="selectedSecteur" class="form-control" id="secteur" v-on:change="changeSecteur()" required>
            <option v-for="secteur in secteurs.data" v-bind:value="secteur" v-bind:item="secteur"
                    v-bind:key="secteur.id">
              {{ secteur.nom }}
            </option>
          </select>
        </div>

        <div class="alert alert-danger" role="alert" v-if="errorMessage">Veuillez indiquer la position GPS de votre
          collecte !
        </div>
        <div class="form-group map-wrapper">
          <label for="coords">Coordonnées</label>
          <div class="map-container">
            <input id="pac-input" class="controls" type="text" placeholder="Barre de recherche" autocomplete="on">
            <gmap-map
              id="gMap"
              ref="gMap"
              :center="center"
              :zoom="15"
              map-type-id="roadmap"
              style="width:100%;  height: 400px;">

              <gmap-marker
                ref="myMarkers"
                :key="index"
                v-for="(m, index) in markers"
                :position="m.position"
                @click="center=m.position"
              ></gmap-marker>
            </gmap-map>
          </div>
        </div>
      </div>

      <div class="buttons">
        <button class="btn btn-primary">Confirmer</button>
        <div class="btn btn-default" v-on:click="$emit('close')">
          Annuler
        </div>
      </div>
    </div>
  </form>
</template>
<script>
/* eslint-disable */
import _ from 'lodash'
import {mapState} from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'moment'

export default {
  computed: {
    ...mapState([
      'secteurs',
      'map',
      'maitrise',
      'currentUser',
      'contenants',
    ]),
    mapStyle: function () {
      const h = document.body.clientHeight - 80
      return 'width: 100%; height: ' + h + 'px'
    },
    center: function () {
      return {lat: this.$store.state.currentVille.coords.lat, lng: this.$store.state.currentVille.coords.lon}
    },
  },
  props: [
    'updateCollecte',
  ],
  data: function () {
    return {
      collecte: this.updateCollecte ? _.cloneDeep(this.updateCollecte) : {},
      referenceExists: false,
      picked: 'non',
      mapLoaded: false,
      position: this.updateCollecte ? {'lat': this.updateCollecte.lat, 'lon': this.updateCollecte.lon} : '',
      selectedSecteur: null,
      currentPlace: null,
      markers: [],
      place: null,
      errorMessage: false,
    }
  },
  methods: {
    changeSecteur: function () {
      this.collecte.secteur_id = this.selectedSecteur.id
      this.collecte.arrondissement_id = this.selectedSecteur.arrondissement_id
    },
    confirm: function () {

      this.referenceExists = this.contenants.data.find(
        (contenant) => contenant.reference === this.collecte.reference.trim() && contenant.id !== this.collecte.id
      )
      if (this.position && this.position.lat !== 0 && this.position.lon && this.position.lon !== 0) {
        this.collecte.lat = this.position.lat
        this.collecte.lon = this.position.lon
        if (this.updateCollecte && !this.referenceExists) {
          this.$store.dispatch('updateContenant', this.collecte)
          this.$emit('close')
        } else if (!this.updateCollecte && !this.referenceExists) {
          this.$store.dispatch('createContenant', this.collecte)
          this.$emit('close')
        }
      } else {
        this.errorMessage = true
      }
    },
    createFromCsv: function () {

    },
  },
  mounted: function () {

    this.$store.dispatch('fetchAllContenants')

    let store = this
    VueGoogleMaps.loaded.then(() => {
      this.mapLoaded = true
      let markerAdded = false
      let gMap = new google.maps.Map(document.getElementById('gMap'), {
        zoom: 15,
        center: {lat: this.$store.state.currentVille.coords.lat, lng: this.$store.state.currentVille.coords.lon}
      })
      if (store.position) {
        let pos = new google.maps.LatLng({lat: store.position.lat, lng: store.position.lon})
        var marker = new google.maps.Marker({
          position: pos,
          map: gMap,
          draggable: true,
        })
        if (this.updateCollecte) {
          this.selectedSecteur = this.secteurs.data.find(secteur =>
            secteur.id === this.collecte.secteur_id)
          google.maps.event.addListener(marker, 'dragend', function (ev) {
            store.position = {'lat': ev.latLng.lat(), 'lon': ev.latLng.lng()}
          })
        }
      }

      var searchBox = new google.maps.places.SearchBox(document.getElementById('pac-input'))
      gMap.controls[google.maps.ControlPosition.TOP_CENTER].push(document.getElementById('pac-input'))
      google.maps.event.addListener(searchBox, 'places_changed', function () {

        searchBox.set('gMap', null)
        var places = searchBox.getPlaces()
        var bounds = new google.maps.LatLngBounds()
        var i, place
        for (i = 0; place = places[i]; i++) {
          (function (place) {
            var marker = new google.maps.Marker({
              position: place.geometry.location
            })
            marker.bindTo('gMap', searchBox, 'gMap')
            google.maps.event.addListener(marker, 'map_changed', function () {
              if (!this.getMap()) {
                this.unbindAll()
              }
            })
            bounds.extend(place.geometry.location)
          }(place))
        }
        gMap.fitBounds(bounds)
        searchBox.set('gMap', gMap)
        gMap.setZoom(Math.min(gMap.getZoom(), 18))
      })

      if (!this.updateCollecte) {
        gMap.addListener('dblclick', function (e) {
          if (!markerAdded) {
            var marker = new google.maps.Marker({
              position: e.latLng,
              map: gMap,
              visible: true,
              draggable: true,
            })
            store.position = {'lat': marker.getPosition().lat(), 'lon': marker.getPosition().lng()}
            markerAdded = true
            google.maps.event.addListener(marker, 'dragend', function (ev) {
              store.position = {'lat': ev.latLng.lat(), 'lon': ev.latLng.lng()}
            })
          }
        })
      }
    })
  },
}
</script>

<style lang="scss">
textarea {
  resize: none;
  height: 140px !important;
}

.map-wrapper {
  position: relative;
  width: 100%;
  height: 400px;

  .map-container {
    height: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// CollecteForm.vue?0ac8e482